export default "__VITE_ASSET__CBxoOBpQ__"